export const messages = {
  en: {
    assetInventoryManage: {
      page: {
        title: 'Asset Inventory',
        subtitle: 'Manage warehouse inventory checks',
        empty: 'No inventory records found'
      },
      search: {
        title: 'Search Conditions',
        staffName: 'Please enter inventory staff',
        state: 'Please select status',
        startTime: 'Please select start time',
        endTime: 'Please select end time'
      },
      list: {
        title: 'Asset Inventory',
        inventory: 'Inventory',
        cancelApply: 'Cancel Application',
        audit: 'Audit'
      },
      table: {
        aiId: 'Inventory No',
        name: 'Inventory Name',
        invTime: 'Inventory Time',
        shName: 'Inventory Warehouse',
        staffName: 'Inventory Staff',
        state: 'Status',
        createTime: 'Create Time'
      },
      delete: {
        title: 'Confirm Operation',
        confirmText: 'Are you sure to delete this asset inventory?'
      },
      cancel: {
        title: 'Confirm Operation',
        confirmText: 'Are you sure to cancel this asset inventory?',
        success: 'Cancel successfully',
        failed: 'Cancel failed'
      }
    }
  },
  zh: {
    assetInventoryManage: {
      page: {
        title: '资产盘点',
        subtitle: '管理仓库盘点任务与审核',
        empty: '暂无盘点记录'
      },
      search: {
        title: '查询条件',
        staffName: '请输入盘点人',
        state: '请选择状态',
        startTime: '请选择开始时间',
        endTime: '请选择结束时间'
      },
      list: {
        title: '资产盘点',
        inventory: '盘点',
        cancelApply: '取消申请',
        audit: '审核'
      },
      table: {
        aiId: '盘点单号',
        name: '盘点名称',
        invTime: '盘点时间',
        shName: '盘点仓库',
        staffName: '盘点人',
        state: '状态',
        createTime: '创建时间'
      },
      delete: {
        title: '确认操作',
        confirmText: '确定删除资产盘点?'
      },
      cancel: {
        title: '确认操作',
        confirmText: '确定取消该次资产盘点?',
        success: '取消成功',
        failed: '取消失败'
      }
    }
  }
}